import { Injectable } from '@angular/core';
import { BreadCrumbItem } from '@progress/kendo-angular-navigation';
import { ActivatedRoute, RouterState } from '@angular/router';
import { Subject } from 'rxjs';
import { IBreadCrumbItem } from '../interfaces/i-breadcrumb-item.interface';
import { RouterExtensionsService } from '../services/router-extensions.service';

@Injectable()
export class BreadCrumbService {

  public breadCrumbEmitter = new Subject<Array<IBreadCrumbItem>>();

  defaultProperty: string = "name";

  constructor(private res: RouterExtensionsService) { }

  breadCrumbs: IBreadCrumbItem[] = [];
  dashboardCrumb: IBreadCrumbItem = {
    url: "/",
    item: {
      text: "Dashboard",
      title: "Dashboard"
    }
  };

  update(route: ActivatedRoute, name: string, entity: any, propertyNames: string[], direct: boolean): void {

    const routerState: RouterState = Reflect.get(route, "_routerState");
    const url: string = routerState?.snapshot.url;

    const previousUrl = this.res.getCurrentUrl();

    this.breadCrumbs = this.getBreadCrumbs();

    var complexNavigation = (url.indexOf("/") !== url.lastIndexOf("/")) && (previousUrl.indexOf("/") !== previousUrl.lastIndexOf("/"));

    if (url === "/" || (url.indexOf("/") === url.lastIndexOf("/")) || complexNavigation) {
      // reset breadcrumbs
      this.breadCrumbs = [];
    }

    if (this.breadCrumbs.length === 0) {
      this.breadCrumbs.push(this.dashboardCrumb);
    }

    var lastBC = this.breadCrumbs[this.breadCrumbs.length - 1];
    if (lastBC.url.includes("/Detail/") && url.includes("/Detail/")) {
      this.breadCrumbs.pop();
    }

    var char: string = "/";

    if (direct) {
      this.reset();
      this.add(name, url);
    } else if (url.includes("/Detail/")) {
      // For Detail pages ... URL = /Item/Detail/1023450001
      name = this.getDisplay(entity, propertyNames);
      if (url.endsWith("0") && (entity == undefined || Object.keys(entity).length == 0)) {
        name = "Add New";
      }

      var currentController = this.breadCrumbs[1].url.split("/")[1];
      var controller = url.split("/")[1];
      if (currentController != controller) {
        this.breadCrumbs.pop();
        this.add(controller, "/" + controller + "/");
      }

      this.add(name, url);

    } else if (url.indexOf(char) !== url.lastIndexOf(char)) {
      // For all other pages
      this.reset();

      let pieces = url.split(char);
      for (var i = 0; i < pieces.length; i++) {
        var p = pieces[i];
        if (p.length > 0) {
          this.add(p, url);
        }
      }

    } else {
      // Mostly for search pages
      // URL = /Item

      this.add(name, url);
    }

    this.setBreadCrumbs();
    this.breadCrumbEmitter.next(this.breadCrumbs);
  }

  setBreadCrumbs(): void {
    localStorage.setItem("redeployment_breadcrumbs", JSON.stringify(this.breadCrumbs));
  }

  getBreadCrumbs(): IBreadCrumbItem[] {

    var breadCrumbs: IBreadCrumbItem[] = [];

    var json = localStorage.getItem("redeployment_breadcrumbs");
    if (json) {
      breadCrumbs = JSON.parse(json.toString());
    }

    return breadCrumbs;
  }

  getBcs(): BreadCrumbItem[] {
    var bcs = this.getBreadCrumbs();
    return bcs.map(b => b.item);
  }

  reset() {
    this.breadCrumbs = [];
    this.breadCrumbs.push(this.dashboardCrumb);
  }

  private add(name: string, url: string): void {
    var item: IBreadCrumbItem = {
      url: url,
      item: {
        text: name,
        title: name
      }
    }

    var texts = this.breadCrumbs.map(b => b.item.text);
    if (!texts.includes(item.item.text)) {
      this.breadCrumbs.push(item);
    }

  }

  getDisplay<T>(entity: T, keys?: string[]): string {
    var s: string = "";
    var o = entity as object;

    if (o == undefined || o == null) {
      return s;
    }

    if (keys === undefined || keys === null) {
      keys = [this.defaultProperty];
    }

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      var v = Reflect.get(o, key);
      if (v) {
        var vs = v.toString();
        s += vs + " ";
      }

    }

    return s;

  }

}
